import turfArea from "@turf/area";
import { SelectionGeometry } from "src/js/stores/map/store";

export function areaHectares(geometry: SelectionGeometry) {
  return turfArea(geometry) / 10000;
}
